import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../helpers/axiosInstance";
import { toast } from "react-toastify";

const initialState = {
    activities: null,
    loading: false,
    error: null,
};

const defaultData = [
    {
        period: "yearly",
        transactionSummary: {
            total: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            pending: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0,
                avgTime: "N/A"
            },
            approved: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            rejected: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            challengeFlow: {
                total: 0,
                success: 0,
                successRate: 0
            },
            frictionlessFlow: {
                total: 0,
                success: 0,
                successRate: 0
            }
        }
    },
    {
        period: "monthly",
        transactionSummary: {
            total: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            pending: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0,
                avgTime: "N/A"
            },
            approved: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            rejected: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            challengeFlow: {
                total: 0,
                success: 0,
                successRate: 0
            },
            frictionlessFlow: {
                total: 0,
                success: 0,
                successRate: 0
            }
        }
    },
    {
        period: "daily",
        transactionSummary: {
            total: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            pending: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0,
                avgTime: "N/A"
            },
            approved: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            rejected: {
                current: 0,
                previous: 0,
                countDifference: 0,
                percentDifference: 0
            },
            challengeFlow: {
                total: 0,
                success: 0,
                successRate: 0
            },
            frictionlessFlow: {
                total: 0,
                success: 0,
                successRate: 0
            }
        }
    }
];

export const postActivityLogs = createAsyncThunk(
    "dashboard/home",
    async ({ user, time }) => {
        try {
            const { url, endpoint } = user.routesConfig;

            const base = url.acsbackofficemanagement;
            const endpointpath = endpoint.acsbackofficemanagement.dashboardstatistics;

            const apiURL = base + endpointpath;

            const response = await axiosInstance.get(apiURL);
            return response?.data;
        } catch (error) {
            toast.error(error.response.data.message);
            throw error.response;
        }
    }
);

const activityLogsSlice = createSlice({
    name: "activityLogs",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(postActivityLogs.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(postActivityLogs.fulfilled, (state, action) => {
                state.loading = false;
                state.activities = action?.payload?.reports || defaultData;
            })
            .addCase(postActivityLogs.rejected, (state, action) => {
                state.loading = false;
                state.activities = defaultData;
                state.error = action.error.message;
            })
    },
});

export default activityLogsSlice.reducer;